import * as React from 'react'

import Button from '../Button'
import Svg from '../Svg'
import doubleChevronRight from '../../../../svg/double-chevron-right-think.svg'
import * as track from '../../track/track'

interface RentThisItemInsteadProps {
  to: string
}

const RentThisItemInstead: React.FC<RentThisItemInsteadProps> = ({to}) => {
  return (
    <Button
      isLink
      className="rental-button"
      to={to}
      onClick={track.clickedBuyPathExperimentRentalControlButton}
    >
      Rent this item instead
      <Svg src={doubleChevronRight} Tag="span" />
    </Button>
  )
}

export default RentThisItemInstead
